<div class="page">
  <back-button (click)="closeConnectionAndGoBack()"></back-button>
  <company-info [company]="company"></company-info>

  <div class="content" *ngIf="companyInfo$ | async as companyInfo">
    <div class="preview-panel" *ngIf="url">
      <div class="preview-toolbar">
        <div class="preview-meta">
          <p class="preview-title">{{ previewDevice.label }}</p>
          <p class="preview-subtitle">
            {{ previewDevice.viewportWidth }} x
            {{ previewDevice.viewportHeight }}
            viewport
          </p>
        </div>
      </div>

      <div
        class="app-container"
        [style.width.px]="previewDevice.shellWidth"
        [style.height.px]="previewDevice.shellHeight"
      >
        <div
          class="phone-frame"
          aria-hidden="true"
          [style.border-radius.px]="previewDevice.frameRadius"
        ></div>
        <div
          class="phone-screen"
          [style.left.px]="previewDevice.screenInsetX"
          [style.top.px]="previewDevice.screenInsetY"
          [style.width.px]="previewDevice.viewportWidth"
          [style.height.px]="previewDevice.viewportHeight"
          [style.border-radius.px]="previewDevice.screenRadius"
        >
          <iframe
            [src]="url"
            frameborder="0"
            id="app-frame"
            title="Wrebit app preview"
          ></iframe>
        </div>
        <div
          class="dynamic-island"
          aria-hidden="true"
          [style.width.px]="previewDevice.islandWidth"
          [style.height.px]="previewDevice.islandHeight"
        ></div>
        <div
          class="home-indicator"
          aria-hidden="true"
          [style.width.px]="previewDevice.homeIndicatorWidth"
        ></div>
      </div>
    </div>

    <aside class="admin-panel">
      <div class="summary-grid">
        <section class="panel-card panel-card--customer">
          <div class="card-header">
            <div>
              <h1 class="card-title">Användardata</h1>
              <p class="card-subtitle">
                Basinformation och supportdata för företaget.
              </p>
            </div>
          </div>

          <div class="data-grid">
            <div class="data-row">
              <span class="data-label">AnvändarId</span>
              <div class="data-entry">
                <span class="data-value">{{ company.ownerId }}</span>
                <button
                  type="button"
                  class="action-icon-button"
                  (click)="copyToClipboard(company.ownerId)"
                  aria-label="Kopiera användarId"
                  title="Kopiera användarId"
                >
                  <mat-icon>content_copy</mat-icon>
                </button>
              </div>
            </div>
            <div class="data-row">
              <span class="data-label">FöretagsId</span>
              <div class="data-entry">
                <span class="data-value">{{ company.id }}</span>
                <button
                  type="button"
                  class="action-icon-button"
                  (click)="copyToClipboard(company.id)"
                  aria-label="Kopiera företagsId"
                  title="Kopiera företagsId"
                >
                  <mat-icon>content_copy</mat-icon>
                </button>
              </div>
            </div>
            <div class="data-row">
              <span class="data-label">Inloggningsmail</span>
              <div class="data-entry">
                <span class="data-value">{{
                  company.adminPortalDisplayData.loginEmail
                }}</span>
                <button
                  type="button"
                  class="action-icon-button"
                  (click)="
                    copyToClipboard(company.adminPortalDisplayData.loginEmail)
                  "
                  aria-label="Kopiera inloggningsmail"
                  title="Kopiera inloggningsmail"
                >
                  <mat-icon>content_copy</mat-icon>
                </button>
              </div>
            </div>
          </div>

          <div class="access-block">
            <div class="block-header">
              <h2 class="block-title">Lösenordsåterställning</h2>
            </div>

            <button
              class="action-button secondary"
              (click)="getPasswordResetLink()"
              [disabled]="isFetchingPasswordReset"
            >
              {{ isFetchingPasswordReset ? 'Hämtar länk...' : 'Hämta länk' }}
            </button>

            <div *ngIf="passwordResetMessage" class="feedback success">
              {{ passwordResetMessage }}
            </div>
            <div *ngIf="passwordResetError" class="feedback error">
              {{ passwordResetError }}
            </div>

            <div
              *ngIf="passwordResetUrl$ | async as passwordResetUrl"
              class="url-container"
            >
              <h4 class="breadtext-link" [title]="passwordResetUrl">
                {{ passwordResetUrl }}
              </h4>
              <button
                type="button"
                class="action-icon-button"
                (click)="copyToClipboard(passwordResetUrl)"
                aria-label="Kopiera återställningslänk"
                title="Kopiera återställningslänk"
              >
                <mat-icon>content_copy</mat-icon>
              </button>
            </div>
          </div>
        </section>

        <section
          class="panel-card panel-card--subscription"
          *ngIf="subscriptionLevel$ | async as subscriptionLevel"
        >
          <div class="card-header">
            <div>
              <h1 class="card-title">Prenumeration</h1>
              <p class="card-subtitle">
                Status och detaljer för kundens abonnemang.
              </p>
            </div>
          </div>

          <div class="subscription-summary">
            <div
              class="subscription-highlight"
              [class.on]="hasPlusAccess"
              [class.off]="!hasPlusAccess"
            >
              <span class="subscription-highlight-label">Status</span>
              <strong class="subscription-highlight-value">
                {{
                  subscriptionLevel === 'base' ||
                  subscriptionLevel === 'undecided'
                    ? 'Ingen PLUS-access'
                    : 'Aktiv prenumeration'
                }}
              </strong>
            </div>
          </div>

          <div class="subscription-detail-box">
            <h2 class="block-title">Prenumerationsstatus</h2>
            <p class="subscription-copy subscriptionInfoTextHandler">
              {{ companyInfo.adminPortalDisplayData.subInfoString }}
            </p>
          </div>
        </section>
      </div>

      <section class="panel-card panel-card--workspace">
        <div class="card-header">
          <div>
            <h1 class="card-title">Åtgärder</h1>
            <p class="card-subtitle">
              Växla mellan olika typer av administrativa åtgärder.
            </p>
          </div>
        </div>

        <!--
          aria-controls is bound rather than fixed. Only the selected panel is
          rendered, and naming an id that is not in the document is invalid
          ARIA - a screen reader announces a relationship to nothing. Keeping
          the panels lazy is worth more than the attribute: rendering all four
          would initialise every tab's children, and the AI one fetches this
          company's quota on init.
        -->
        <div
          class="segment-control"
          role="tablist"
          aria-label="Administrativa åtgärder"
          aria-orientation="horizontal"
        >
          <button
            type="button"
            class="segment-button"
            role="tab"
            id="segment-tab-ai"
            [attr.aria-controls]="
              activeSegment === 'ai' ? 'segment-panel-ai' : null
            "
            [class.active]="activeSegment === 'ai'"
            [class.segment-button--selected]="activeSegment === 'ai'"
            [attr.aria-selected]="activeSegment === 'ai'"
            [attr.tabindex]="activeSegment === 'ai' ? 0 : -1"
            (click)="setActiveSegment('ai')"
            (keydown)="onSegmentKeydown($event, 'ai')"
          >
            AI Agent
          </button>
          <button
            type="button"
            class="segment-button"
            role="tab"
            id="segment-tab-access"
            [attr.aria-controls]="
              activeSegment === 'access' ? 'segment-panel-access' : null
            "
            [class.active]="activeSegment === 'access'"
            [class.segment-button--selected]="activeSegment === 'access'"
            [attr.aria-selected]="activeSegment === 'access'"
            [attr.tabindex]="activeSegment === 'access' ? 0 : -1"
            (click)="setActiveSegment('access')"
            (keydown)="onSegmentKeydown($event, 'access')"
          >
            Åtkomst
          </button>
          <button
            type="button"
            class="segment-button"
            role="tab"
            id="segment-tab-exports"
            [attr.aria-controls]="
              activeSegment === 'exports' ? 'segment-panel-exports' : null
            "
            [class.active]="activeSegment === 'exports'"
            [class.segment-button--selected]="activeSegment === 'exports'"
            [attr.aria-selected]="activeSegment === 'exports'"
            [attr.tabindex]="activeSegment === 'exports' ? 0 : -1"
            (click)="setActiveSegment('exports')"
            (keydown)="onSegmentKeydown($event, 'exports')"
          >
            Exporter
          </button>
          <button
            type="button"
            class="segment-button segment-button--danger"
            role="tab"
            id="segment-tab-risk"
            [attr.aria-controls]="
              activeSegment === 'risk' ? 'segment-panel-risk' : null
            "
            [class.active]="activeSegment === 'risk'"
            [class.segment-button--selected]="activeSegment === 'risk'"
            [attr.aria-selected]="activeSegment === 'risk'"
            [attr.tabindex]="activeSegment === 'risk' ? 0 : -1"
            (click)="setActiveSegment('risk')"
            (keydown)="onSegmentKeydown($event, 'risk')"
          >
            Aiia-integration
          </button>
        </div>

        <div
          class="segment-panel"
          id="segment-panel-access"
          role="tabpanel"
          aria-labelledby="segment-tab-access"
          tabindex="0"
          *ngIf="activeSegment === 'access'"
        >
          <div
            *ngIf="subscriptionLevel$ | async as subscriptionLevel"
            class="access-block"
          >
            <div class="block-header">
              <div>
                <h2 class="block-title">PLUS-access</h2>
                <p class="support-text">
                  Ge företaget PLUS-access till ett valt datum om kunden ligger
                  på grundnivå.
                </p>
              </div>
              <span
                class="small-status"
                [class.on]="
                  subscriptionLevel !== 'base' &&
                  subscriptionLevel !== 'undecided'
                "
                [class.off]="
                  subscriptionLevel === 'base' ||
                  subscriptionLevel === 'undecided'
                "
              >
                {{
                  subscriptionLevel === 'base' ||
                  subscriptionLevel === 'undecided'
                    ? 'Kan ges'
                    : 'Har redan PLUS'
                }}
              </span>
            </div>

            <div
              *ngIf="
                subscriptionLevel == 'base' || subscriptionLevel == 'undecided';
                else plusAlreadyGrantedTpl
              "
              class="inline-form"
            >
              <mat-form-field appearance="fill" class="date-picker-container">
                <mat-label>Välj utgångsdatum</mat-label>
                <input
                  matInput
                  [matDatepicker]="picker"
                  [(ngModel)]="grantPlusExpirationYear"
                />
                <mat-hint>ÅÅÅÅ/MM/DD</mat-hint>
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>

              <mat-checkbox
                class="is-trial-checkbox"
                (change)="updateGrantIsTrial($event)"
              >
                Ska vara gratisperiod
              </mat-checkbox>
            </div>

            <ng-template #plusAlreadyGrantedTpl>
              <p class="support-text">
                Företaget har redan en prenumerationsnivå över grundnivå.
              </p>
            </ng-template>

            <button
              *ngIf="
                subscriptionLevel == 'base' || subscriptionLevel == 'undecided'
              "
              class="action-button primary"
              (click)="grantPlusAccess()"
              [disabled]="grantPlusExpirationYear == null || isGrantingPlus"
            >
              {{ isGrantingPlus ? 'Ger access...' : 'Ge PLUS-access' }}
            </button>

            <div *ngIf="plusAccessMessage" class="feedback success">
              {{ plusAccessMessage }}
            </div>
            <div *ngIf="plusAccessError" class="feedback error">
              {{ plusAccessError }}
            </div>
          </div>
        </div>

        <div
          class="segment-panel"
          id="segment-panel-ai"
          role="tabpanel"
          aria-labelledby="segment-tab-ai"
          tabindex="0"
          *ngIf="activeSegment === 'ai'"
        >
          <div class="ai-agent-block">
            <div class="access-block">
              <div class="block-header">
                <div>
                  <h2 class="block-title">AI-chatt</h2>
                  <p class="support-text">
                    Styr om företaget ska se ingången till AI-chatt i mobilappen.
                  </p>
                </div>
                <span
                  class="small-status"
                  [class.on]="aiChatIsEnabled"
                  [class.off]="!aiChatIsEnabled"
                >
                  {{ aiChatIsEnabled ? 'Aktiverad' : 'Avaktiverad' }}
                </span>
              </div>

              <div class="button-row">
                <button
                  class="action-button primary"
                  (click)="setAiChatEnabled(true)"
                  [disabled]="aiChatIsEnabled || isUpdatingAiChat"
                >
                  Aktivera AI-chatt
                </button>
                <button
                  class="action-button tertiary"
                  (click)="setAiChatEnabled(false)"
                  [disabled]="!aiChatIsEnabled || isUpdatingAiChat"
                >
                  Avaktivera AI-chatt
                </button>
              </div>

              <div *ngIf="aiChatUpdateMessage" class="feedback success">
                {{ aiChatUpdateMessage }}
              </div>
              <div *ngIf="aiChatUpdateError" class="feedback error">
                {{ aiChatUpdateError }}
              </div>
            </div>
          </div>

          <div class="ai-agent-block">
            <app-ai-chat-quota [companyId]="company?.id"></app-ai-chat-quota>
          </div>
        </div>

        <div
          class="segment-panel"
          id="segment-panel-exports"
          role="tabpanel"
          aria-labelledby="segment-tab-exports"
          tabindex="0"
          *ngIf="activeSegment === 'exports'"
        >
          <div class="export-block">
            <div class="block-header">
              <div>
                <h2 class="block-title">Exporter</h2>
                <p class="support-text">
                  Välj ett räkenskapsår innan du exporterar bokföringsdata.
                </p>
              </div>
            </div>

            <mat-form-field appearance="outline" class="year-field">
              <mat-label>Räkenskapsår</mat-label>
              <mat-select [formControl]="financialYearControl">
                <mat-option
                  *ngFor="let financialYear of financialYears"
                  [value]="financialYear"
                >
                  {{ financialYear.start | date: 'yyyy-MM-dd' }} -
                  {{ financialYear.end | date: 'yyyy-MM-dd' }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <div class="export-actions">
              <sie-export
                [token]="companyToken"
                [disabled]="!selectedFinancialYear"
                [selectedFinancialYear]="selectedFinancialYear"
                [company]="company"
              ></sie-export>

              <ledger-company-account-export
                [token]="companyToken"
                [disabled]="!selectedFinancialYear"
                [selectedFinancialYear]="selectedFinancialYear"
                [company]="company"
              ></ledger-company-account-export>

              <p class="hint" *ngIf="!selectedFinancialYear">
                Välj räkenskapsår för att aktivera export.
              </p>
            </div>
          </div>
        </div>

        <div
          class="segment-panel segment-panel--danger"
          id="segment-panel-risk"
          role="tabpanel"
          aria-labelledby="segment-tab-risk"
          tabindex="0"
          *ngIf="activeSegment === 'risk'"
        >
          <div class="access-block">
            <div class="block-header">
              <div>
                <h2 class="block-title">Aiia integration</h2>
                <p class="support-text">
                  Att nollställa Aiia tar bort kopplade bankkonton och ska bara
                  göras för att återställa en trasig integration.
                </p>
              </div>
              <span
                class="small-status"
                [class.on]="($aiiaIntegrationId | async) !== null"
                [class.off]="($aiiaIntegrationId | async) === null"
              >
                {{
                  ($aiiaIntegrationId | async) ? 'Ansluten' : 'Inte ansluten'
                }}
              </span>
            </div>

            <app-reset-aiia-integration
              [integrationId]="$aiiaIntegrationId | async"
              [disabled]="false"
            ></app-reset-aiia-integration>
          </div>
        </div>
      </section>
    </aside>
  </div>
</div>
